export default __webpack_public_path__ + "static/media/ntk.594f3153.webp";